import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, MessageCircle } from 'lucide-react';
import { siteInfo } from '../mockData';
import { contactInfo } from '../config/siteConfig';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-[#F5F3EB] border-t border-[#DCB071]/40 overflow-hidden font-sans">
      <img
        src="/motif-azulejo.png"
        alt=""
        className="absolute right-0 bottom-0 w-64 opacity-[0.07] pointer-events-none select-none"
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <img src="/logo_1-transparent.png" alt="Tamila Hachemi" className="h-11 w-auto object-contain" />
            <p className="text-[#4A4458] text-sm leading-relaxed">
              {siteInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-[#21167D] font-accent">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-[#4A4458] hover:text-[#21167D] transition-colors text-sm">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/qui-suis-je" className="text-[#4A4458] hover:text-[#21167D] transition-colors text-sm">
                  Qui suis-je ?
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-[#4A4458] hover:text-[#21167D] transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#4A4458] hover:text-[#21167D] transition-colors text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/rendez-vous" className="text-[#4A4458] hover:text-[#21167D] transition-colors text-sm">
                  Prendre RDV
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-[#21167D] font-accent">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#21167D] flex-shrink-0 mt-0.5" />
                <span className="text-[#4A4458] text-sm">{siteInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#21167D] flex-shrink-0" />
                <a href={contactInfo.phoneHref} className="text-[#4A4458] text-sm hover:text-[#21167D] transition-colors">
                  {siteInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <MessageCircle className="w-5 h-5 text-[#21167D] flex-shrink-0" />
                <a
                  href={contactInfo.whatsappHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#4A4458] text-sm hover:text-[#21167D] transition-colors"
                >
                  WhatsApp : {contactInfo.whatsapp}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#21167D] flex-shrink-0" />
                <a href={`mailto:${siteInfo.email}`} className="text-[#4A4458] text-sm hover:text-[#21167D] transition-colors break-all">
                  {siteInfo.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-[#21167D] font-accent">Horaires</h4>
            <div className="flex items-start space-x-3">
              <Clock className="w-5 h-5 text-[#21167D] flex-shrink-0 mt-0.5" />
              <div className="text-[#4A4458] text-sm">
                <p>Lundi - Vendredi</p>
                <p className="font-medium text-[#21167D]">9h00 - 19h00</p>
                <p className="mt-2 text-xs text-[#4A4458]/70">Sur rendez-vous uniquement</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#DCB071]/40">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[#4A4458] text-sm">
              © {currentYear} {siteInfo.name}. Tous droits réservés.
            </p>
            <div className="flex space-x-6 text-sm text-[#4A4458]">
              <Link to="/mentions-legales" className="hover:text-[#21167D] transition-colors">
                Mentions légales
              </Link>
              <Link to="/politique-de-confidentialite" className="hover:text-[#21167D] transition-colors">
                Politique de confidentialité
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
